import React, { useState } from "react";
import {
  Box,
  Checkbox,
  IconButton,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import ComponentBackdrop from "../../components/backdrop";
import {  Visibility } from "@mui/icons-material";
import CustomToolbar from "../../utils/customToolbar";

const Listing = ({ dataList, handleShowButton }) => {
  const rows = dataList
    .filter(item => item.status !== "Cancelled")

  const navigate = useNavigate();

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const handleClose = () => {
    setOpenBackdrop(false);
  };

  const onSelectedCheckbox = (id, rows) => {
    let selectedIds = [];

    if (id.type === 'include') {
      selectedIds = Array.from(id.ids);
    }
    else if (id.type === 'exclude') {
      const excluded = new Set(id.ids);
      selectedIds = rows.filter(row => !excluded.has(row.id)).map(row => row.id);
    }
    // console.log("selectCheckBox:", selectedIds);
    handleShowButton(selectedIds);
  }

  const navigateDetails = (id) => {
    navigate(`/view-mission/${id}`);
  }

  const columns = [
    {
      field: "Actions",
      headerName: "Action",
      width: 100,
      type: "actions",
      hideable: false,
      getActions: (params) => [
        <IconButton
          sx={{ color: "#39493F" }}
          onClick={() => navigateDetails(params.row.id)} // 👈 navigate with row id
        >
          <Tooltip title="View" placement="right">
            <Visibility />
          </Tooltip>
        </IconButton>,
      ],
    },
    {
      field: "missionId",
      headerName: "ID",
      width: 80,
    },
    {
      field: "title",
      headerName: "Title",
      width: 200,
    },
    {
      field: "description",
      headerName: "Description",
      width: 180,
    },
    {
      field: "valueTag",
      headerName: "Value Tag",
      width: 180,
    },
    {
      field: "missionLevel",
      headerName: "Difficulty",
      width: 100,
    },
    {
      field: "missionScheduleType",
      headerName: "Schedule",
    },
    {
      field: "startDate",
      headerName: "Start Date",
      width: 120,
      valueGetter: (params) => {

        if (params) {
          const formatted = dayjs(params).format('DD-MM-YYYY');
          return formatted;
        }
      }
    },
    {
      field: "endDate",
      headerName: "End Date",
      width: 120,
      valueGetter: (params) => {

        if (params) {
          const formatted = dayjs(params).format('DD-MM-YYYY');
          return formatted;
        }
      }
    },
    {
      field: "point",
      headerName: "Point",
      minWidth: 100,
    },
    {
      field: "isContinueOnHoliday",
      headerName: "Continue on Holiday",
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Checkbox
          checked={params.value}
          disabled 
          sx={{
            '&.Mui-checked': { color: '#959968ff' },
            padding: 0,
            margin: 'auto'
          }}
        />
      ),
    },
    {
      field: "isApproval",
      headerName: "Approval",
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Checkbox
          checked={params.value}
          disabled
          sx={{
            '&.Mui-checked': { color: '#959968ff' },
            padding: 0,
            margin: 'auto'
          }}
        />
      ),
    },
    {
      field: "isPenalty",
      headerName: "Penalty",
      minWidth: 100,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Checkbox
          checked={params.value}
          disabled
          sx={{
            '&.Mui-checked': { color: '#959968ff' },
            padding: 0,
            margin: 'auto'
          }}
        />
      ),
    },
    {
      field: "penaltyPoint",
      headerName: "Penalty Point",
      minWidth: 150,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 150,

      valueGetter: (params) => {
        const value = params;
        if (value === "InProgress") return "In Progress";
        return value; 
      },
    },
    //uncomment after team field is added to the json
    // {
    //   field: "teamId",
    //   headerName: "Team",
    //   minWidth: 200,
    // },
    {
      field: "createdDate",
      headerName: "Created Date",
      minWidth: 150,
      valueGetter: (params) => {

        if (params) {
          const formatted = dayjs(params).format('DD-MM-YYYY');
          return formatted;
        }
      }
    },
    {
      field: "createdName",
      headerName: "Created By",
      width: 150,
      // flex: 1,
    },

  ];

  return (
       <Box
        style={{
          width: "100%",
          height: "77vh",
          overflowY: rows.length > 10 ? "auto" : "visible", // scroll if too many
        }}
      >
        <ComponentBackdrop open={openBackdrop} close={handleClose} />
        <DataGrid
          columns={columns}
          rows={rows}
          showToolbar
          slots={{ toolbar: CustomToolbar }}
          pageSizeOptions={[50, 100, { value: 500, label: "500" }]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 50 },
            },
            sorting: {
              sortModel: [
                { field: "startDate", sort: "desc" }, // ✅ sort by createdDate desc
              ],
            },
            filter: {
              filterModel: {
                items: [
                  {
                    field: "status",
                    operator: "equals",
                    value: "In Progress", // ✅ default filter
                  },
                ],
              },
            },
            columns: {
              columnVisibilityModel: {
                missionId: false,
                description: false,
                missionScheduleType: false,
                isContinueOnHoliday: false,
                isApproval: false,
                isPenalty: false,
                penaltyPoint: false,
                createdDate: false,
                createdName: false
              },
            },
          }}
          slotProps={{
            toolbar: {
              title: ""
            },
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "skeleton",
            },
            disableToolbarButton: {
              csvOptions: "true",
              printOptions: "true"
            },
            toolbar: {
              printOptions: { disableToolbarButton: true },
              csvOptions: { disableToolbarButton: true }
            },
          }}
          // checkboxSelection
          onRowSelectionModelChange={(id) => {
            onSelectedCheckbox(id, rows);
          }
          }
          disableRowSelectionOnClick
          localeText={{ noRowsLabel: "No records found" }}
        />
      </Box>
  );
};

export default Listing;

